import React, { useState, useContext, forwardRef } from "react";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import { ModelTsContext } from "../../context/modelTS.context";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// (#79) AppContext import removed — re-added in #114 Phase 4.5 for isTimeTraveling.
import { AppContext } from "../../context/app.context";
import TextArea from "../../components/TextArea";
import ReadOnlyShield from "../../components/ReadOnlyShield";

function ExtraCellAddModal({ jobsDetail, setOpenExtraCellAddModal }) {
  // (#79) Removed 5 dead useState declarations: currPage, currentJob,
  // currentExpedite, currentDistant, pagination. All were scaffolding that
  // was never wired up to UI. changesFlag is real and stays.
  const [changesFlag, setChangesFlag] = useState(false);
  const [customText, setCustomText] = useState("");
  const { tsCreateExtraCellAttribute } = useContext(ModelTsContext);
  const { isTimeTraveling } = useContext(AppContext);
  // (#79) AppContext destructure removed — setOpenSuppressModal was destructured
  // but never called in this file. Add back if/when this modal needs to open Suppress.
  const [currentDate, setCurrentDate] = useState();
  const [currentSurface, setCurrentSurface] = useState("Soft Surface");

  // - - - - - - - - - -

  const onCancel = () => {
    if (
      window.confirm("Are you sure you want to exit without saving changes?")
    ) {
      // User clicked OK
      // Close modal window
      setOpenExtraCellAddModal({ show: false });
    } else {
      // User clicked Cancel
    }
  };

  // - - - - - - - - - -

  const onSave = () => {
    // 2025-04-03 - require a value in customText
    if (customText === "") {
      window.alert("A value in the Custom Notes field is required.");
      //
    } else {
      //only save if changes have been made
      console.log("ExtraCellAddModal onSave, currentSurface: ", currentSurface);
      if (changesFlag) {
        var surfaceToUse = "";
        if (currentSurface === "Soft Surface" || currentSurface === "Carpet") {
          surfaceToUse = "Carpet";
        } else {
          surfaceToUse = "Hard Surface";
        }

        // Use TanStack directly (Realm EOL Jan 13, 2026)
        tsCreateExtraCellAttribute(currentDate, surfaceToUse, customText);
        console.log(
          "ExtraCellAddModal onSave, dateL: ",
          currentDate,
          ", surfaceToUse: ",
          surfaceToUse,
          ", customText: ",
          customText
        );
      }

      // Close modal window
      setOpenExtraCellAddModal({ show: false });
    }
  };

  // - - - - - - - - - -

  const onDateChange = (date) => {
    setChangesFlag(true);
    const fmDate = new Date(Date.parse(date)).toLocaleDateString("en-us");
    setCurrentDate(fmDate);
    console.log(
      "ExtraCellAddModal onDateChange, date: ",
      date,
      ", fmDate: ",
      fmDate
    );
  };

  // - - - - - - - - - -

  const onSurfaceChange = (newSurface) => {
    setChangesFlag(true);
    setCurrentSurface(newSurface);
    console.log("ExtraCellAddModal onSurfaceChange, newSurface: ", newSurface);
  };

  // -------

  const onChangeCustomText = (customText) => {
    setChangesFlag(true);
    setCustomText(customText);
  };

  // - - - - - - - - - -

  const EstCompleteInput = forwardRef(({ value, onClick, className }, ref) => (
    <button
      onClick={onClick}
      ref={ref}
      className="flex items-center hover:opacity-75 cursor-pointer"
    >
      <span className={className}>{value}</span>
      <span className="ml-1 arrow arrow-down arrow-small"></span>
    </button>
  ));

  // - - - - - - - - - -

  return (
    <Modal
      onClose={() =>
        !changesFlag ? setOpenExtraCellAddModal({ show: false }) : onCancel()
      }
    >
      <Modal.Header>
        <div className="flex justify-between">
          <div>Extra Cell</div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <ReadOnlyShield>
        <div className="flex flex-col gap-4 w-[400px]">
          <div className="text-lg font-bold">Required information</div>
          <div className="flex flex-wrap">
            <div className="flex-1 basis-2/4">Date</div>
            <div className="flex-1 basis-2/4 font-bold">
              <DatePicker
                selected={currentDate}
                onChange={(date) => onDateChange(date)}
                customInput={
                  <EstCompleteInput className="flex-1 basis-2/4 font-bold text-skin-link" />
                }
                dateFormat="M/d/YYYY"
              />
            </div>
            <div className="flex-1 basis-2/4">Surface</div>
            <div className="flex-1 basis-2/4 text-black">
              <select
                className="bg-yellow-30 text-black text-sm font-medium hover:opacity-75 cursor-pointer"
                value={currentSurface}
                onChange={(e) => onSurfaceChange(e.target.value)}
              >
                <option value="Soft Surface">Soft Surface</option>
                <option value="Hard Surface">Hard Surface</option>
              </select>
            </div>
          </div>
          <div className="flex flex-col gap-1 p-2 bg-skin-surface-hard">
            <div>
              <TextArea
                placeholder="Custom Notes"
                rows={10}
                value={customText}
                onChange={(e) => onChangeCustomText(e.target.value)}
                className="bg-skin-base border border-black border-opacity-20 "
              ></TextArea>
            </div>
          </div>
          <div></div>
        </div>
        </ReadOnlyShield>
      </Modal.Content>
      <Modal.Footer>
        <div className="flex flex-col items-center w-full gap-4">
          <div className="h-8 flex justify-between w-full">
            {/* Time Machine #114 Phase 4.5 — hide Save in read-only mode. */}
            {!isTimeTraveling ? (
              <Button
                className="uppercase w-31"
                onClick={() => onSave()}
                disabled={!changesFlag}
              >
                Save
              </Button>
            ) : null}
            {!isTimeTraveling && changesFlag ? (
              <Button
                color="light"
                className="uppercase w-31"
                onClick={() => onCancel()}
              >
                Cancel
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ExtraCellAddModal;
